up.compiler('[data-spoiler-reveal]', (spoiler: HTMLElement) => {
  up.on(spoiler, 'click', () => {
    spoiler.classList.toggle('-revealed')
  })
})

up.compiler('[data-spoiler-section-reveal]', (spoilerSection: HTMLElement) => {
  const index = spoilerSection.getAttribute('data-spoiler-section-reveal')

  up.on(spoilerSection, 'click', (event: Event) => {
    spoilerSection.classList.toggle('-revealed')

    const spoilers = spoilerSection.parentNode!.querySelectorAll(`[data-spoiler-reveal="${index}"]`)
    const isRevealed = spoilerSection.matches('.-revealed')

    spoilerSection.textContent = isRevealed
      ? 'alle Lösungen ausblenden'
      : 'alle Lösungen einblenden'
    spoilers.forEach((spoiler) => {
      spoiler.classList.toggle('-revealed', isRevealed)
    })

    up.event.halt(event)
  })
})
